import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import Images from "@/assets/images";
import Icons from "@/assets/icons";
import { FontFamilies, Typography } from "@/constants/Typography";

export default function WelcomeSlide3() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>Find lost checks under your name.</Text>
      <View style={styles.cardList}>
        {/* Row 1 */}
        <View style={styles.cardRow}>
          <Icons.ReturnBrown />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Uncashed payroll checks ($352)</Text>
            <Text style={styles.cardSubtitle}>Held by State of California</Text>
          </View>
          <Text style={styles.claimText}>Claim</Text>
        </View>
        {/* Row 2 */}
        <View style={styles.cardRow}>
          <Icons.CloseRed />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>
              Closed account with Chase ($79)
            </Text>
            <Text style={styles.cardSubtitle}>Held by State of California</Text>
          </View>
          <Text style={styles.claimText}>Claim</Text>
        </View>
        {/* Row 3 */}
        <View style={styles.cardRow}>
          <Icons.ReturnBrown />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Refund from Verizon ($29)</Text>
            <Text style={styles.cardSubtitle}>Held by State of California</Text>
          </View>
          <Text style={styles.claimText}>Claim</Text>
        </View>
        {/* Row 4 */}
        <View style={styles.cardRow}>
          <Icons.ReturnBrown />
          <View style={styles.cardTextBox}>
            <Text style={styles.cardTitle}>Government refunds ($154)</Text>
            <Text style={styles.cardSubtitle}>Held by State of California</Text>
          </View>
          <Text style={styles.claimText}>Claim</Text>
        </View>
      </View>
      {/* Review box */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv3} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @DannyDiaz2: &quot;Easy to use, only took a few minutes, and well
            worth it. Thankful I found Sparrow, or did Sparrow find me?&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  cardList: {
    width: "92%",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    position: "relative",
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  cardRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.08)",
  },
  cardTextBox: {
    flex: 1,
    marginLeft: 12,
  },
  cardTitle: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 15,
  },
  cardSubtitle: {
    color: "#ffffff50",
    fontFamily: FontFamilies.Inter.Regular,
    marginTop: 2,
    fontSize: 10,
  },
  claimText: {
    color: "#A3F2A3",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 11,
    marginLeft: 12,
    textDecorationLine: "underline",
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  reviewContent: {
    flex: 1,
    marginLeft: 12,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
  },
});
